import React from 'react';
import { Empty } from 'antd';
import { useHistory } from 'react-router-dom';
import { Notification } from '..';
import BASE_URL from '../../configs/baseUrl';
import Button from '../button';
import { NotificationWrapper } from './style';

const NotificationComponent = (props) => {
  const history = useHistory();
  const { isShow, notificationList, onClickReadAllNotifications } = props;

  const onClickNotification = () => {
    history.push(BASE_URL.NOTIFICATIONS);
  };

  return (
    <NotificationWrapper isShow={isShow}>
      <div className="container_page_header_notification">
        <div className="component_notification_header">
          <div className="font-subtitle1_medium component_notification_header_title">
            Notification
          </div>
          {notificationList?.length > 0 && (
            <span
              className="font-paragraph_medium component_notification_header_mark"
              aria-hidden="true"
              onClick={() => {
                onClickReadAllNotifications();
              }}
            >
              Mark All as Read
            </span>
          )}
        </div>
        <div className="component_notification_body">
          {notificationList?.map((item) => {
            return (
              <div
                aria-hidden="true"
                key={item.id}
                className="component_notification_list_item"
                // onClick={() => {
                // }}
              >
                <Notification dataSource={item} smallPadding />
              </div>
            );
          })}
          {notificationList?.length === 0 && (
            <div className="component_notification_empty">
              <Empty description={false}>
                <div className="font-caption_medium component_notification_empty_text">
                  No notifications yet!
                </div>
              </Empty>
            </div>
          )}
        </div>
        {notificationList?.length > 0 && (
          <div className="component_notification_footer">
            <Button
              className="component_button_primary_transparent"
              block
              onClick={onClickNotification}
            >
              See all notifications
            </Button>
          </div>
        )}
      </div>
    </NotificationWrapper>
  );
};

export default NotificationComponent;
